import RedirectUriSettings from "./RedirectUriSettings";
export default RedirectUriSettings;
